/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../onboard/activation/status';
import '../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "common": {
            "nested": {
              "Error": {
                "fields": {
                  "field": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "message": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "StatusResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.onboarding.common.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "dataValidationResults": {
                    "type": ".squareup.onboard.activation.status.ValidationResult",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "JpAddress": {
                "fields": {
                  "agrexCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "prefectureCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "chomeBanchi": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "kanjiAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 4,
                    "rule": "optional"
                  },
                  "katakanaAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.common?.nested?.Error && !$root.nested?.squareup?.nested?.onboarding?.nested?.common?.nested?.StatusResponse && !$root.nested?.squareup?.nested?.onboarding?.nested?.common?.nested?.JpAddress) {
  $root.addJSON(jsonData);
}

/**
 * A general-purpose error object.
 * Please use or extend this message rather than rolling a new one for your specific purpose.
 *
 * SOURCE Error @ squareup/onboarding/common.proto at 13:1
 */
export const Error = $root.lookupType('squareup.onboarding.common.Error');
fixType(Error);
Builder.createAndAttachToType(Error);
/**
 * A general-purpose response object.
 *
 * SOURCE StatusResponse @ squareup/onboarding/common.proto at 20:1
 */
export const StatusResponse = $root.lookupType('squareup.onboarding.common.StatusResponse');
fixType(StatusResponse);
Builder.createAndAttachToType(StatusResponse);
/**
 * Used to capture a JP address, which is extremely complex and cannot be captured using a
 * singular GlobalAddress.
 *
 * SOURCE JpAddress @ squareup/onboarding/common.proto at 35:1
 */
export const JpAddress = $root.lookupType('squareup.onboarding.common.JpAddress');
fixType(JpAddress);
Builder.createAndAttachToType(JpAddress);